export enum MeetingSidebarTabEnum {
  details = "Details",
  topics = "Topics",
  meetings = "Meetings",
  artifacts = "Items",
  askAI = "Ask AI",
  workHistory = "Work history",
  rolesAndReviews = "Career",
  myNotes = "My Notes",
}

export const meetingSidebarAriaLabel = "Meeting Sidebar";

/**
 * The sidebar tab a meeting page should open on.
 *
 * Sandbox/demo users land on the Work history tab so they immediately discover
 * the feature when entering a 1-on-1 (TF-1410). Everyone else keeps the regular
 * Items default. When the Work history tab isn't actually available for a given
 * meeting (non 1-on-1, or feature disabled) the sidebar's own fallback resets to
 * the first available tab.
 */
export const getDefaultMeetingSidebarTab = ({
  isDemoUser,
  workHistoryEnabled,
}: {
  isDemoUser: boolean;
  workHistoryEnabled: boolean;
}): MeetingSidebarTabEnum =>
  isDemoUser && workHistoryEnabled
    ? MeetingSidebarTabEnum.workHistory
    : MeetingSidebarTabEnum.artifacts;
